// Constantes de tiempo para UX
export const UX_TIMING = {
  LOADING_MIN_TIME: 1500, // 1.5 segundos mínimo para UX
  SUCCESS_DISPLAY_TIME: 2500, // 2.5 segundos para mostrar éxito
  ERROR_DISPLAY_TIME: 3000, // 3 segundos para mostrar error
};

// Lista de permisos disponibles
export const AVAILABLE_PERMISSIONS = [
  { key: 'view_dashboard', label: 'Ver Dashboard' },
  { key: 'manage_users', label: 'Gestionar Usuarios' },
  { key: 'manage_contacts', label: 'Gestionar Contactos' },
  { key: 'manage_devices', label: 'Gestionar Dispositivos' },
  { key: 'manage_templates', label: 'Gestionar Plantillas' },
  { key: 'view_logs', label: 'Ver Logs' },
  { key: 'manage_subscriptions', label: 'Gestionar Suscripciones' },
  { key: 'send_messages', label: 'Enviar Mensajes' },
];

// Roles de usuario (debe ir ANTES de ROLE_PERMISSIONS)
export const USER_ROLES = {
  ADMIN: 'admin',
  COLLABORATOR: 'colaborador',
};

// Definición de acciones por tipo
export const PERMISSION_ACTIONS = {
  READ: 'read',
  CREATE: 'create', 
  UPDATE: 'update',
  DELETE: 'delete',
};

// Permisos por rol
export const ROLE_PERMISSIONS = {
  [USER_ROLES.ADMIN]: {
    view_dashboard: true,
    manage_users: true,
    manage_contacts: true,
    manage_devices: true,
    manage_templates: true,
    view_logs: true,
    manage_subscriptions: true,
    send_messages: true,
  },
  [USER_ROLES.COLLABORATOR]: {
    // Colaborador solo puede VER/LEER
    view_dashboard: true,
    manage_users: false,
    manage_contacts: false,
    manage_devices: false,
    manage_templates: false,
    view_logs: true,
    manage_subscriptions: false,
    send_messages: false,
  },
};

// Estados de operaciones
export const OPERATION_STATUS = {
  CREATING: 'creating',
  SUCCESS: 'success',
  ERROR: 'error',
  CONFIRM: 'confirm',
  LOADING: 'loading',
};

// Breakpoints para responsive
export const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1200,
};

// Estados de contactos
export const CONTACT_STATUS = {
  ACTIVE: 'Activo',
  INACTIVE: 'Inactivo',
};

// Estados de suscripciones
export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'activa',
  SUSPENDED: 'suspendida',
  CANCELLED: 'cancelada',
  EXPIRED: 'vencida',
};

// Planes de suscripciones
export const SUBSCRIPTION_PLANS = {
  MONTHLY: 'mensual',
  BIANNUAL: 'semestral',
  ANNUAL: 'anual',
};

// Métodos de pago disponibles
export const PAYMENT_METHODS = {
  CREDIT_CARD: 'tarjeta_credito',
  BANK_TRANSFER: 'transferencia',
  CASH: 'efectivo',
};

// Colores del tema
export const THEME_COLORS = {
  PRIMARY: '#111827',
  SECONDARY: '#6b7280',
  LIGHT_GRAY: '#f9fafb',
  BORDER: '#e5e7eb',
  BORDER_LIGHT: '#e5e7eb',
  BORDER_HOVER: '#d1d5db',
  BACKGROUND_DEFAULT: '#f9fafb',
  BACKGROUND_PAPER: '#ffffff',
  TEXT_PRIMARY: '#111827',
  TEXT_SECONDARY: '#374151',
  TEXT_MUTED: '#6b7280',
  WHITE: '#ffffff',
  SHADOW_LIGHT: 'rgba(0, 0, 0, 0.1)',
}; 